import styled from 'styled-components';
import InfinityImg from '@/assets/icons/Infinity.png';

export const WelcomeOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WelcomeContainer = styled.div`
  width: 720px;
  height: 417px;
  background-color: #1a1a1a;
  overflow: hidden;
  text-align: left;
  font-size: 20px;
  color: #fff;
  font-family: 'PingFang SC';
  position: relative;
  display: flex;
`;

export const WelcomeLeftPanel = styled.div`
  width: 50%;
  height: 100%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #000 0%, #000 28%, rgba(0, 0, 0, 0) 58%);
    z-index: 34;
    pointer-events: none;
  }
`;

export const WelcomeRightPanel = styled.div`
  width: 50%;
  height: 100%;
`;

export const HiIconWrapper = styled.div`
  position: absolute;
  top: 113px;
  left: 172px;
  font-size: 40px;
  letter-spacing: -0.04em;
  line-height: 40px;
  font-family: 'Racing Sans One';
  z-index: 44;
`;

export const WelcomeText = styled.div`
  position: absolute;
  top: 157px;
  left: 112px;
  letter-spacing: 0.1em;
  line-height: 40px;
  z-index: 44;
`;

export const BrandName = styled.div`
  position: absolute;
  top: 157px;
  left: 206px;
  letter-spacing: 0.1em;
  line-height: 40px;
  font-weight: 600;
  background: linear-gradient(90deg, #ff8b00, #f74f01);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  z-index: 55;
`;

export const InfinityBg = styled.div`
  width: 100%;
  height: 282px;
  object-fit: cover;
  position: absolute;
  bottom: -4px;
  left: 0;
  background: url(${InfinityImg}) no-repeat;
  z-index: 33;
`;

export const WelcomeHeading = styled.div`
  position: absolute;
  top: 119px;
  left: 426px;
  line-height: 20px;
  font-weight: 600;
`;

export const WelcomeSubtitle = styled.div`
  position: absolute;
  top: 151px;
  left: 426px;
  font-size: 16px;
  line-height: 16px;
`;

export const GiftText = styled.div`
  position: absolute;
  top: 207px;
  left: 426px;
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  background: linear-gradient(90deg, #ffa357, #e46443);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const BtnWrapper = styled.div`
  position: absolute;
  top: 258px;
  left: 431px;
  width: 240px;
  height: 40px;
  font-size: 14px;
  cursor: pointer;
`;

export const BtnContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 240px;
  height: 40px;
`;

export const BtnBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 36px;
  background: linear-gradient(122.95deg, #feae45, #ff6d49 68.75%);
  width: 240px;
  height: 40px;
`;

export const BtnLabel = styled.div`
  position: absolute;
  top: 13px;
  left: 92px;
  line-height: 14px;
  font-weight: 600;

`;

export const WelcomeCloseIcon = styled.img`
  position: absolute;
  top: 24px;
  right: 24px;
  width: 28px !important;
  height: 28px !important;
  box-sizing: border-box;
  border-radius: 50%;
  background-color: #2f2f2f;
  padding: 5px;
  cursor: pointer;
`;

export const WelcomeDouWrapper = styled.div`
  position: relative;
  padding-top: 34px;
`;

export const WelcomeDou = styled.div`
  width: 204px;
  border-radius: 8px;
  background: linear-gradient(165.51deg, #e55020 0%, #e55020 15%, #1d1a16 50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 34px 16px;
  gap: 8px;
  position: relative;

  & img {
    width: 68px;
    height: 68px;
    position: absolute;
    top: -34px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const DouText = styled.div`
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  font-family: 'PingFang SC';
  color: #fff;
  text-align: center;
  padding-top:18px;
  padding-bottom:14px;
`;

export const DouMlText = styled.div`
  font-size: 12px;
  line-height: 12px;
  font-weight: 500;
  font-family: 'PingFang SC';
  color: #f8a749;
  text-align: center;
`;